define("analytics-resources/components/analytics-resource/legend", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tAN--legend" ...attributes>
    {{#each @legendItems as |item|}}
      <span
        class="tAN--legend__color tAN--legend__color--{{if item.colorName item.colorName this.defaultColor}}
          {{if item.isLine 'tAN--legend__line'}}"
      ></span>
      <span class="tAN--legend__text {{if @isUppercase 'u--text--uppercase'}}">
        {{item.text}}
        {{#if item.tooltip}}
          <EmberTooltip @event="hover" @side="bottom">
            <span>
              {{item.tooltip}}
            </span>
          </EmberTooltip>
        {{/if}}
      </span>
    {{/each}}
    {{yield}}
  </div>
  */
  {
    "id": "IaJspg6N",
    "block": "[[[11,0],[24,0,\"tAN--legend\"],[17,1],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,2]],null]],null],null,[[[1,\"    \"],[10,1],[15,0,[29,[\"tAN--legend__color tAN--legend__color--\",[52,[30,3,[\"colorName\"]],[30,3,[\"colorName\"]],[30,0,[\"defaultColor\"]]],\"\\n        \",[52,[30,3,[\"isLine\"]],\"tAN--legend__line\"]]]],[12],[13],[1,\"\\n    \"],[10,1],[15,0,[29,[\"tAN--legend__text \",[52,[30,4],\"u--text--uppercase\"]]]],[12],[1,\"\\n      \"],[1,[30,3,[\"text\"]]],[1,\"\\n\"],[41,[30,3,[\"tooltip\"]],[[[1,\"        \"],[8,[39,3],null,[[\"@event\",\"@side\"],[\"hover\",\"bottom\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[1,[30,3,[\"tooltip\"]]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[3]],null],[1,\"  \"],[18,5,null],[1,\"\\n\"],[13]],[\"&attrs\",\"@legendItems\",\"item\",\"@isUppercase\",\"&default\"],false,[\"each\",\"-track-array\",\"if\",\"ember-tooltip\",\"yield\"]]",
    "moduleName": "analytics-resources/components/analytics-resource/legend.hbs",
    "isStrictMode": false
  });
  class LegendComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "defaultColor", 'teal');
    }
  }
  _exports.default = LegendComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LegendComponent);
});